import ReportVisitor from "../../../../models/reports/reports/ReportVisitor.js";

/**
 * Visitor used to compute the width of a PDF column when exported.
 * Basic columns should be "auto" yet the spacer can have different width
 * based on their type.
 */
export default class PdfColumnWidthVisitor extends ReportVisitor {
	visitAbstractColumn() {
		return "auto";
	}

	visitSeparatorColumn(column) {
		return column.isNarrow() ? 10 : 40;
	}
}
